import { type FC, type PropsWithChildren } from "react";

export const ColumnHeaderLabel: FC<PropsWithChildren & { htmlFor: string }> = ({
	htmlFor,
	children,
}) => {
	return (
		<label className="text-sm font-bold text-tertiary" htmlFor={htmlFor}>
			{children}
		</label>
	);
};
